import React from 'react';
import { CountrySectionData } from '../../data/sections/ConuntrySectionData';

const Contribution = ({ country }) => {
  // Find the selected country from data or use the passed prop

 const fetchedCountryDetail =
  country
    ? CountrySectionData.countries.find((c) => 
        c.country.replace(/\s+/g, '-').toLowerCase() ===
        country.replace(/\s+/g, '-').toLowerCase())
    : null;

if (!fetchedCountryDetail) {
  return <p>Country not found or data not available.</p>;
}


   

  // Ensure contributions are defined
  const employerContributions = fetchedCountryDetail.employer_contributions || {};
  
  const employeeContributions = fetchedCountryDetail.employee_contributions || {};
  const incomeTaxSlabs = fetchedCountryDetail.income_tax_slabs || [];

  return (
    <div className="contribution-container">
      <h1>Contributions for {fetchedCountryDetail.country}</h1>

      {/* Employer Contributions */}
      <section>
      
        <table className="contribution-table ">
          <thead>
          <tr>
            <th colSpan="3"><h3>Employer Payroll Contributions</h3></th>
          </tr>
            <tr>
              <th>Contribution Type</th>
              <th>Rate</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(employerContributions).map(([key, value], idx) => (
              <tr key={`employer-${idx}`}>
                <td>{key.replace(/_/g, ' ').toUpperCase()}</td>
                <td>{value.rate || 0}%</td>
                <td>{value.description || 'No description available'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      {/* Employee Contributions */}
      <section>
        <table className="contribution-table">
          <thead>
          <tr>
            <th colSpan="3"><h3>Employee Payroll Contributions</h3></th>
          </tr>
            <tr>
              <th>Contribution Type</th>
              <th>Rate</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(employeeContributions).map(([key, value], idx) => (
              <tr key={`employee-${idx}`}>
                <td>{key.replace(/_/g, ' ').toUpperCase()}</td>
                <td>{value.rate || 0}%</td>
                <td>{value.description || 'No description available'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      {/* Income Tax Slabs */}
      <section>
        <table className="contribution-table tax">
          <thead>
          <tr>
            <th colSpan="3"><h3>Income Tax Slabs</h3></th>
          </tr>
            <tr>
              <th>Tax Rate</th>
              <th>Income Range</th>
            </tr>
          </thead>
          <tbody>
            {incomeTaxSlabs.map((slab, idx) => (
              <tr key={`tax-slab-${idx}`}>
                <td>{slab.rate || 0}%</td>
                <td>{slab.range}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default Contribution;
